/**
 * Background component - clean base for custom animations
 */
export function KeyboardBackground() {
  return (
    <div className="fixed inset-0 z-0">
      {/* Base dark background */}
      <div className="absolute inset-0 bg-[#050508]" />

      {/* Gradient overlays for text readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-dark via-transparent to-dark/40 pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-dark/60 via-transparent to-transparent pointer-events-none" />
    </div>
  );
}
